import { RouterType } from '@online-webinar/router';
import { EditExamPage } from '@online-webinar/webinar-management';
import { authGuard } from '../integrations/auth-guard';

export const updateRoute = (router: RouterType) => {
    router.routesById['/$webinarId/edit-exam'].update({
        staticData: { title: { page: 'EditExam.Pageheading', forWebinar: true } },
        component: authGuard(EditExamPage, { canBroadcast: true })
    });
};
